export default __webpack_public_path__ + "static/media/exitfullscreen.9802d091.svg";